var map = {
	"./25SSD-BW7LVV4F.png": "pBxX",
	"./25SSDB-CKtRdoR0.png": "LmpZ",
	"./AI-BCH693Hz.png": "M6SM",
	"./DEV1-CKwh8lpv.png": "+1CG",
	"./DEV2-CT-gIGRl.png": "C8Nr",
	"./DEV3-B-d0PvMF.png": "fcSD",
	"./DEV4-dPqPDurT.png": "yWJp",
	"./DVB-DrSUgOfH.png": "01Ur",
	"./DVB2-DjkE-_08.png": "sn1O",
	"./DVB3-Biyw4GzV.png": "upm9",
	"./DVB4-CjM7gZe9.png": "sXzT",
	"./EMMC-CbAF51gR.png": "zFbq",
	"./EMMC200-i74F8zny.png": "+ARl",
	"./EMMCB-CnUyHTnb.png": "ynYa",
	"./EMMCr-B5rWE7Y1.png": "biV7",
	"./FBS-F3eJZ9B7.png": "SJOA",
	"./FWXTP-BFaa0jfU.png": "Hg6G",
	"./Fwxp-dHW8lLyX.png": "SpPl",
	"./M.2 SSD-QwYZmJp2.png": "iIEW",
	"./M2SSD-D-Tyyskw.png": "FxgP",
	"./M2SSDB-B0sdhH5t.png": "DEQE",
	"./Markbj-Cbaj2YBu.png": "G9hh",
	"./NVME-D50RFZhg.png": "ZmEp",
	"./QYSJP-DPAWTr3b.png": "RlXR",
	"./SIP-BDUvpnss.png": "S5TQ",
	"./SIPB-BYTSGiYY.png": "k/3c",
	"./SMT-DcgK3LLR.png": "RDdU",
	"./SpecialSSD-BFrVTRHJ.png": "/Xwm",
	"./UFS-BCPUJxHT.png": "hzJr",
	"./UFSB-DKSZekpn.png": "0qvY",
	"./about-r24nIKT6.png": "LO0/",
	"./abvl-D66gZMS2.png": "UHx5",
	"./abvlr-BFO0Rfku.png": "lUIa",
	"./aisc-kRFGc_PO.png": "jFI4",
	"./banner1-Cz5FJ_ZW.png": "+G9Q",
	"./banneren-CqoSed6l.png": "M/Sn",
	"./btlogo-DUhNTl3P.png": "ZqeB",
	"./ccmz-CyQYbsaT.png": "vl1q",
	"./ccsb-C57crC8_.png": "+ZbK",
	"./contus2-E5up-mG9.png": "BcJO",
	"./copyrigh.png": "ivmf",
	"./cp1-DmBHZhvM.png": "WPYZ",
	"./cp2-r4vjOU1w.png": "HTR4",
	"./cp3-coHF1HI2.png": "U1uD",
	"./cpzx-rP_JuD7r.png": "FbL0",
	"./cpzxgl-DypE9E8r.png": "Dtsb",
	"./cscj-Bu9rl2Yg.png": "C1vp",
	"./four-bg-DF1WlLbX.png": "BrIu",
	"./gsjsbj-Dgjxi0Nf.png": "i1kn",
	"./gsysbg-D99bLSNL.png": "Jepx",
	"./gy-BKaQN8yv.png": "x36P",
	"./gyhlwsc-BlhdT1hS.png": "8JgW",
	"./gywm-KwURyTex.png": "Wfqm",
	"./jj-DXdRVO9a.png": "yuDy",
	"./kapianwenli.png": "xZ22",
	"./khdpc-nVVnI4Mp.png": "w7go",
	"./logo-CK3Ah_zb.png": "+tvV",
	"./logoyw-2M8_saDq.png": "VHte",
	"./lxwm2x-51ivQMbM.png": "ImJY",
	"./mark1-Biamh3q4.png": "xbis",
	"./mark2-BLLBmBgP.png": "H1qM",
	"./mark3-BGnW_V-t.png": "oqb8",
	"./mark4-DxM9vvdf.png": "JGNQ",
	"./mark5-ecC1u8V4.png": "//4X",
	"./mark6-CdDIbaU9.png": "tziO",
	"./mark7-gdAAEgCo.png": "cpT8",
	"./mark8-D3kPTiRD.png": "c7x3",
	"./mobilesc-CIF21pF9.png": "xY9c",
	"./new1-CfyVfWeL.png": "Dac8",
	"./new10-Tg2vNs9U.png": "FLXF",
	"./new2-CpdygOmA.png": "3wOG",
	"./new3-8pD6ochW.png": "99+1",
	"./new4-CfbMmQJw.png": "JTla",
	"./new5-BXePd3Zp.png": "cpMI",
	"./new6-Kp9wQm2E.png": "0Rdu",
	"./new7-Zr4tLn7V.png": "urD6",
	"./new8-Hd6yBx3J.png": "h/b1",
	"./new9-Mw8cRk5P.png": "9ZGq",
	"./pc-J6welF73.png": "OFwX",
	"./pzb-D4Ymfm-n.png": "T9Zz",
	"./qc-B-0o_1QI.png": "xiYu",
	"./qrsxp-BlilOf5v.png": "hHSi",
	"./qyjB-CnZLE4sh.png": "1/Hp",
	"./sccar-BLP8sjMY.png": "Zpwm",
	"./scyhy-D8o1Ve7V.png": "pXEx",
	"./scyhydd-BLOVE5Yr.png": "EFn4",
	"./sjzxdd-DhhawDyN.png": "GxHI",
	"./third-DVFjfGNx.png": "I2bV",
	"./wdgc2x-BcOQNpLb.png": "29sh",
	"./whjzg-XGJFoko6.png": "se9x",
	"./whsm-20f8Wjbb.png": "iQbc",
	"./whyj-Bp22ZHAw.png": "0Pyn",
	"./wl-0-6V2Kak.png": "A8rU",
	"./wljcsbsc-CuxqpB18.png": "XUWI",
	"./xsyzc-CLpAfVhZ.png": "MUV7",
	"./xsyzc2x-D3aQCj_P.png": "/Qdu",
	"./xwzx2x-BSkHWAXV.png": "+VpX",
	"./ysbj-DI3_66Vp.png": "GnEM",
	"./yxdtd-ChzySjJK.png": "OXAb",
	"./zhjjsc-BJUdTMI0.png": "kVMu",
	"./zljsbg2-C-ShHaQC.png": "0cv5",
	"./zp0-D5GlfLLc.png": "RxIL",
	"./zxfw-NRopHoA8.png": "+pJK",
	"./zxzx-B4CqnfDV.png": "tevj"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g9m1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2 ^\.\/.*\.png$
// module id = g9m1
// module chunks = 16